/*
 * Floyd product swatch and Color It Up synchronization.
 * Tracking consumers remain isolated in floyd-commerce-tracking.js.
 */
(function () {
    var ccwcDataBySection = new WeakMap();

    function getCcwcData(section) {
        if (!section || !window.FloydCcwcMapping) return [];
        if (!ccwcDataBySection.has(section)) {
            ccwcDataBySection.set(section, window.FloydCcwcMapping.parse(section));
        }
        return ccwcDataBySection.get(section);
    }

    function getSwatchName(label) {
        var span = label && label.querySelector('span.sr-only');
        if (span && span.textContent) return span.textContent.trim();
        var img = label && label.querySelector('img');
        if (img && img.alt) return img.alt.split('#')[0].trim();
        return '';
    }

    function getLabelForInput(input) {
        if (!input || !input.id) return null;
        return document.querySelector('label.thumbnail-swatch[for="' + input.id + '"]');
    }

    function getEventContext(label) {
        var configurator = label && label.closest && label.closest('floyd-wheel-campaign-product, floyd-wheel-campaign-landing');
        return {
            source: configurator || null,
            context: configurator ? 'wheel-configurator' : 'storefront'
        };
    }

    function createEventDetail(name, label) {
        var eventContext = getEventContext(label);
        return {
            caseColor: name,
            label: label,
            source: eventContext.source,
            context: eventContext.context
        };
    }

    function getProductCarts() {
        var carts = [];
        var cartsEl = document.querySelectorAll('[data-floyd-color-it-up] .product-card');
        for (var i = 0; i < cartsEl.length; i++) {
            var cart = cartsEl[i];
            if (cart) {
                carts.push(cart);
            }
        }
        return carts;
    }

    function changeCartImg(carts, caseColor) {
        var section = carts[0] && carts[0].closest('[data-floyd-color-it-up]');
        var jsonData = getCcwcData(section);
        if (!jsonData.length) return;

        for (var i = 0; i < carts.length; i++) {
            var cart = carts[i];
            if (cart) {
                var primaryImg = cart.querySelector('.product-card__image--primary');
                if (!primaryImg) {
                    continue;
                }
                if (primaryImg) {
                    var wheelColor = cart.getAttribute('data-floyd-wheel-color') || '';
                    if (!wheelColor) continue;

                    var item = window.FloydCcwcMapping.find(jsonData, caseColor, wheelColor);
                    if (item) {
                        var imageSrc = item.image;
                        if (imageSrc.startsWith('//')) {
                            imageSrc = 'https:' + imageSrc;
                        }

                        var imageUrl = new URL(imageSrc, window.location.origin);
                        var imageWidths = [200, 300, 400, 500];
                        primaryImg.srcset = imageWidths.map(function (width) {
                            var renditionUrl = new URL(imageUrl);
                            renditionUrl.searchParams.set('width', String(width));
                            return renditionUrl.toString() + ' ' + width + 'w';
                        }).join(', ');

                        imageUrl.searchParams.set('width', '500');
                        primaryImg.src = imageUrl.toString();
                    }
                }
            }
        }
    }

    function updateColorItUp(detail) {
        if (detail.context === 'wheel-configurator') return;
        var carts = getProductCarts();
        if (carts.length > 0) {
            changeCartImg(carts, detail.caseColor);
        }
    }

    function emitSwatchEvent(eventName, name, label) {
        var detail = createEventDetail(name, label);
        updateColorItUp(detail);
        document.dispatchEvent(new CustomEvent(eventName, {detail: detail}));
    }

    // Delegate label clicks.
    document.addEventListener('click', function (e) {
        var label = e.target.closest && e.target.closest('label.thumbnail-swatch');
        if (!label) return;
        var name = getSwatchName(label);
        console.log('[swatch click]', name);
        emitSwatchEvent('swatch:clicked', name, label);
    });

    // Find checked radio swatches within a scope and emit the existing events.
    function findCheckedAndEmit(root, fireInit) {
        var scope = root || document;
        var inputs = scope.querySelectorAll('input[type="radio"][data-option-position], input[type="radio"][name*="option"]');
        var seenAny = false;
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (input.checked) {
                seenAny = true;
                var label = getLabelForInput(input);
                var name = getSwatchName(label);
                if (fireInit) emitSwatchEvent('swatch:initialized', name, label);
                emitSwatchEvent('swatch:changed', name, label);
            }
        }
        return seenAny;
    }

    function initOnReady() {
        var found = findCheckedAndEmit(document, true);
        if (!found) {
            setTimeout(function () {
                findCheckedAndEmit(document, true);
            }, 150);
            setTimeout(function () {
                findCheckedAndEmit(document, true);
            }, 350);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOnReady);
    } else {
        initOnReady();
    }

    document.addEventListener('change', function (e) {
        var target = e.target;
        if (!target || target.type !== 'radio') return;
        if (target.checked) {
            var label = getLabelForInput(target);
            var name = getSwatchName(label);
            emitSwatchEvent('swatch:changed', name, label);
        }
    }, true);

    // Preserve support for app-driven DOM and checked-state updates.
    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var mutation = mutations[i];

            if (mutation.type === 'childList') {
                for (var j = 0; j < mutation.addedNodes.length; j++) {
                    var node = mutation.addedNodes[j];
                    if (node && node.nodeType === 1) {
                        findCheckedAndEmit(node, false);
                    }
                }
            }

            if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
                var element = mutation.target;
                if (element && element.nodeType === 1 && element.tagName === 'INPUT' && element.type === 'radio' && element.checked) {
                    var label = getLabelForInput(element);
                    var name = getSwatchName(label);
                    emitSwatchEvent('swatch:changed', name, label);
                }
            }
        }
    });
    observer.observe(document.documentElement || document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked']
    });
})();
